module.exports = {
  localeName: 'pt-PT',
  momentFormat: 'DD-MM-YYYY',
};
